module.exports = __webpack_public_path__ + "img/CrossChainBridge_icon1.19284e6f.svg";